import {
  BUSCAR_TRAMITE_POR_FECHA_SUCCESS,
  BUSCAR_TRAMITE_POR_FECHA_ERROR,
  OBTENER_DIRECCIONES_SUCCESS,
  OBTENER_DIRECCIONES_ERROR,
  OBTENER_DIRECCIONES_ELEGIBILIDAD_SUCCESS,
  OBTENER_DIRECCIONES_ELEGIBILIDAD_ERROR,
  VALIDAR_AFILIADO_SUCCESS,
  VALIDAR_AFILIADO_ERROR,
  VALIDAR_AFILIADO_ELEGIBILIDAD_SUCCESS,
  VALIDAR_AFILIADO_ELEGIBILIDAD_ERROR,
  GUARDAR_DATOS_CONECTIVIDAD_SUCCESS,
  GUARDAR_DATOS_CONECTIVIDAD_ERROR,
  GUARDAR_DATOS_ELEGIBILIDAD_SUCCESS,
  GUARDAR_DATOS_ELEGIBILIDAD_ERROR,
  OBTENER_PRESTACIONES_SUCCESS,
  OBTENER_PRESTACIONES_ERROR,
  OBTENER_CODIGO_DIAGNOSTICO_SUCCESS,
  OBTENER_CODIGO_DIAGNOSTICO_ERROR,
  VALIDAR_COBERTURA_SUCCESS,
  VALIDAR_COBERTURA_ERROR,
  GET_CIRCLE_DATA_SUCCESS,
  GET_CIRCLE_DATA_ERROR,
  GUARDAR_DATOS_INGRESAR_DIAGNOSTICO_SUCCESS,
  GUARDAR_DATOS_INGRESAR_DIAGNOSTICO_ERROR,
  GUARDAR_DATOS_ANULAR_DIAGNOSTICO_SUCCESS,
  GUARDAR_DATOS_ANULAR_DIAGNOSTICO_ERROR,
  GUARDAR_DATOS_REIMPRESION_SUCCESS,
  GUARDAR_DATOS_REIMPRESION_ERROR,
  GUARDAR_DATOS_ANULAR_PRESTACION_SUCCESS,
  GUARDAR_DATOS_ANULAR_PRESTACION_ERROR,
  OBTENER_PRESTACIONES_EXCEPTUADAS_SUCCESS,
  OBTENER_PRESTACIONES_EXCEPTUADAS_ERROR,
  RESET_CONNECTIVITY_STATE,
  RESET_TRANSACTION,
} from '../constants';
import { isEmpty } from 'lodash';

export default function altaConectividad(state = {}, action) {
  const newState = { ...state };
  switch (action.type) {
    case BUSCAR_TRAMITE_POR_FECHA_SUCCESS:
      newState.busquedaTramites = action.data;
      return newState;
    case BUSCAR_TRAMITE_POR_FECHA_ERROR:
      newState.busquedaTramites = 'Error';
      return newState;
    case GUARDAR_DATOS_CONECTIVIDAD_SUCCESS:
      newState.guardarDatos = action.data;
      return newState;
    case OBTENER_PRESTACIONES_EXCEPTUADAS_SUCCESS:
      newState.prestacionesExceptuadas = action.data;
      return newState;
    case OBTENER_PRESTACIONES_EXCEPTUADAS_ERROR:
      newState.prestacionesExceptuadas = 'Error';
    case GUARDAR_DATOS_CONECTIVIDAD_ERROR:
      newState.guardarDatos = 'Error';
      return newState;
    case GUARDAR_DATOS_ANULAR_PRESTACION_SUCCESS:
      newState.guardarDatosAnularPrestacion = action.data;
      return newState;
    case GUARDAR_DATOS_ANULAR_PRESTACION_ERROR:
      newState.guardarDatosAnularPrestacion = 'Error';
      return newState;
    case GUARDAR_DATOS_ELEGIBILIDAD_SUCCESS:
      newState.guardarDatosElegibilidad = action.data;
      return newState;
    case GUARDAR_DATOS_ELEGIBILIDAD_ERROR:
      newState.guardarDatosElegibilidad = 'Error';
      return newState;
    case GUARDAR_DATOS_INGRESAR_DIAGNOSTICO_SUCCESS:
      newState.guardarDatosIngresarDiagnostico = action.data;
      return newState;
    case GUARDAR_DATOS_INGRESAR_DIAGNOSTICO_ERROR:
      newState.guardarDatosIngresarDiagnostico = 'Error';
      return newState;
    case GUARDAR_DATOS_ANULAR_DIAGNOSTICO_SUCCESS:
      newState.guardarDatosAnularDiagnostico = action.data;
      return newState;
    case GUARDAR_DATOS_ANULAR_DIAGNOSTICO_ERROR:
      newState.guardarDatosAnularDiagnostico = 'Error';
      return newState;
    case GUARDAR_DATOS_REIMPRESION_SUCCESS:
      newState.guardarDatosReImpresion = action.data;
      return newState;
    case GUARDAR_DATOS_REIMPRESION_ERROR:
      newState.guardarDatosReImpresion = 'Error';
      return newState;
    case OBTENER_PRESTACIONES_SUCCESS:
      newState.prestaciones = action.data;
      return newState;
    case OBTENER_PRESTACIONES_ERROR:
      newState.prestaciones = [];
      return newState;
    case OBTENER_CODIGO_DIAGNOSTICO_SUCCESS:
      newState.diagnosticos = isEmpty(action.data) ? [] : action.data;
      return newState;
    case OBTENER_CODIGO_DIAGNOSTICO_ERROR:
      newState.diagnosticos = [];
      return newState;
    case OBTENER_DIRECCIONES_SUCCESS:
      newState.direcciones = action.data;
      return newState;
    case OBTENER_DIRECCIONES_ERROR:
      newState.direcciones = 'Error';
      return newState;
    case OBTENER_DIRECCIONES_ELEGIBILIDAD_SUCCESS:
      newState.direccionesElegibilidad = action.data;
      return newState;
    case OBTENER_DIRECCIONES_ELEGIBILIDAD_ERROR:
      newState.direccionesElegibilidad = 'Error';
      return newState;
    case VALIDAR_AFILIADO_SUCCESS:
      newState.validarAfiliado = action.data;
      return newState;
    case VALIDAR_AFILIADO_ERROR:
      newState.validarAfiliado = { isValid: false };
      return newState;
    case VALIDAR_AFILIADO_ELEGIBILIDAD_SUCCESS:
      newState.validarAfiliadoElegibilidad = action.data;
      return newState;
    case VALIDAR_AFILIADO_ELEGIBILIDAD_ERROR:
      newState.validarAfiliadoElegibilidad = { isValid: false };
      return newState;
    case GET_CIRCLE_DATA_ERROR:
      newState.circleData = 'Error';
      return newState;
    case GET_CIRCLE_DATA_SUCCESS:
      newState.circleData = action.data;
      return newState;
    case VALIDAR_COBERTURA_SUCCESS:
      newState.cobertura = action.data;
      return newState;
    case VALIDAR_COBERTURA_ERROR:
      newState.cobertura = 'Error';
      return newState;
    case RESET_CONNECTIVITY_STATE:
      return {};
    case RESET_TRANSACTION:
      return {
        ...state,
        guardarDatosIngresarDiagnostico: {},
        guardarDatosAnularDiagnostico: {},
        guardarDatosReImpresion: {},
        guardarDatosAnularPrestacion: {},
      };

    default:
      return newState;
  }
}
